import Cookies from 'js-cookie';

type CookieAttributes = typeof Cookies.attributes;

export enum CookKey {
	Appointment = 'appt',
	BodySpecUser = 'bodyspec-user',
	Checkout = 'checkout',
	CookieBanner = 'cookie-banner',
	ExitSurvey = 'exit-survey',
	LeadCapture = 'lead-capture',
	LocalId = 'local-id',
	// observer-aid/-sid are set by the BodySpec app on its in-app WebViews
	// so web sessions stitch to the app session that opened them
	ObserverAppAnon = 'observer-aid',
	ObserverAppSession = 'observer-sid',
	ObserverFirstTouch = 'observer-ft',
	ObserverSession = 'observer-session',
	OrderRegion = 'order-region',
	PrivacyOptOut = 'privacy-opt-out',
	Product = 'product',
	Referrer = 'referrer',
	Region = 'region',
	Token = 'token',
}

export const cookies = {
	get(k: CookKey): string | undefined {
		return Cookies.get(k);
	},

	set(k: CookKey, v: string, attr?: CookieAttributes) {
		Cookies.set(k, v, attr);
	},

	remove(k: CookKey, attr?: CookieAttributes) {
		Cookies.remove(k, attr);
	},
};
